export default __webpack_public_path__ + "static/media/down-arrow-black.e360f955.svg";